var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "メール受信設定",
          },
        }),
        _vm._v(" "),
        _c("p", [_vm._v("通知メールの受信設定を行います。")]),
        _vm._v(" "),
        _c("form-item-group", {
          attrs: {
            options: _vm.receivableMailTypeOptions,
            "form-label-class-name": "pega-form-label-account",
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        メール受信設定 \n        "),
                  _c("small", [_vm._v("(任意)")]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.receivableMailTypes,
            callback: function ($$v) {
              _vm.receivableMailTypes = $$v
            },
            expression: "receivableMailTypes",
          },
        }),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "button-class": "pega-width-auto",
                "submit-label": "この内容で保存する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.onRegisterClick },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }